export enum BinLocationsTabsEnum {
  GENERAL_STOCK = 'general_stock',
  RETURNS_STOCK = 'returns_stock',
  DELETED = 'deleted',
}
